// extracted by mini-css-extract-plugin
export default {"menu-element":"MenuElement_menu-element__tSfbE","menu-element--active":"MenuElement_menu-element--active__3T1kE","icon":"MenuElement_icon__dxS3F","text":"MenuElement_text__5CDnk"};